<template>
    <div class='tbqd twoBox' v-if='tbdwmc'>
        <div class="redBox">
            <p class='red' v-if='!isBegin'>签到未开始</p>
            <div v-else>
                <p>签到剩余时间</p>
                <myClock :key="'myClock-' + shenyu" class='small lf' :shenyu='shenyu' cId='c1' @clock="tbqdshenyuFun"></myClock>
            </div>
        </div>
        <div class="box">
            <table class='show'>
                <colgroup width='160px'></colgroup>
                <tr>
                    <td>投标单位</td>
                    <td>{{tbdwmc}}</td>
                </tr>
                <tr>
                    <td>签到时间</td>
                    <td>
                        <span v-html="qdsj"></span>
                    </td>
                </tr>
            </table>
        </div>
        <!-- 签到弹窗 -->
        <el-dialog :visible.sync="visible" width="1100px" title="签到" :close-on-click-modal='false' v-if='visible'>
            <qdCom ref='qdCom' @Qd='caQd' @ewmQd='ewmQd'></qdCom>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>正在进行有效性审查，请耐心等待...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
import qdCom from '../components/qdCom'
import { PreciseInterval } from '@/utils/date-time-display.js';
export default {
    name:'tbqd',
    props:['djlcId'],
    components:{
        myClock,qdCom
    },
    data(){
        return{
            isBegin:true,
            shenyu:0,
            tbdwmc:'',
            qdsj:'',
            sfqd:false,//是否已签到
            visible:false,
            // intervalTbqd:null,
            preciseInterval: null,
            jgdm:'',
        }
    },
    methods:{
        getData(){
            let para={
                djlcId:this.djlcId
            }
            const starTime = +new Date();
            this.$api.kbqdTbr(para).then(res=>{
                if(res.data.meta.success){
                    this.isBegin=res.data.data.sfqd=='0'?false:true;//招标人是否开启签到
                    const currentTime = new Date();
                    const delay = currentTime.getTime() - starTime;
                    this.shenyu = res.data.data.djs - delay;

                    console.log('接口请求耗时：', delay);
                    console.log('接口返回倒计时：', res.data.data.djs);
                    console.log('当前系统时间：', currentTime);
                    console.log('根据倒计时计算当前时间:', this.shenyu, new Date(res.data.data.kbsj - this.shenyu))
                    console.log('国家授时时间:', document.querySelector('.time').innerText)
                    if(res.data.data.tbdw){
                        this.tbdwmc=res.data.data.tbdw.fcqymc;
                        this.jgdm=res.data.data.tbdw.fcqyjgdm;
                        this.sfqd=res.data.data.tbdw.sfqd=='0'?false:true;//投标人是否已签到
                        if(this.shenyu>=1000){
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='';
                                this.tbqdshenyuFun();
                            }
                        }else{
                            //签到倒计时结束
                            if(this.sfqd){
                                this.qdsj=this.$moment(res.data.data.tbdw.qdsj).format("YYYY-MM-DD HH:mm:ss");
                            }else{
                                this.qdsj='<span class="red">未签到</span>'
                            }
                        }
                    }else{
                        this.tbdwmc=localStorage.getItem('user');
                        if(this.shenyu>=1000){
                            this.qdsj='';
                            this.tbqdshenyuFun();
                        }else{
                            //签到倒计时结束
                            this.qdsj='<span class="red">未签到</span>';
                            let obj={
                                lx:'tb',
                                data:{
                                    index:0,
                                    msg:'3',
                                    all:false
                                }
                            }
                            this.$emit('send',JSON.stringify(obj))
                            }
                    }
                    
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //投标人点击签到按钮操作
        tbrDo(lx){
            if(lx=='tbqd'){
                this.visible=true;
            }
        },
        //计算剩余时间倒计时
        // tbqdshenyuFun(){
        //     var _this=this;
        //     var time=_this.shenyu
        //     clearInterval(_this.intervalTbqd);
        //     _this.intervalTbqd=null;
        //     _this.intervalTbqd=setInterval(function(){
        //         if(time<1000){
        //             clearInterval(_this.intervalTbqd);
        //              _this.intervalTbqd=null;
        //             if(!_this.sfqd){
        //                 _this.qdsj='<span class="red">未签到</span>';
        //                 let obj={
        //                     lx:'tb',
        //                     data:{
        //                         index:0,
        //                         msg:'3',
        //                         all:false
        //                     }
        //                 }
        //                 _this.$emit('send',JSON.stringify(obj))
        //             }
        //             clearInterval(_this.intervalTbqd);
        //              _this.intervalTbqd=null;
        //             return;
        //         }
        //         time=time-2000;
        //     },2000)
        // }, 
        tbqdshenyuFun(countdownTime) {
            const time = countdownTime || this.shenyu
            // 保留原倒计时结束未签到业务逻辑
            if (time >= 1000) return
            if (this.sfqd) return
            this.qdsj = '<span class="red">未签到</span>';
            const obj = {
                lx: 'tb',
                data: {
                    index: 0,
                    msg: '3',
                    all: false
                }
            }
            this.preciseInterval?.stop();
            this.$emit('send', JSON.stringify(obj))
        },
        //签到成功后关闭弹窗更新页面数据
        caQd(obj){ 
            this.$refs.qdCom.waitLoading = true
            let para={
                jgdm:obj.jgdm,
                caNo:obj.code,
                sftbr:true
            }
            this.$api.caQd(para).then(res=>{
                if(res.data.meta.success){
                    this.$message({
                        type:'success',
                        message:'签到成功！'
                    })
                    this.visible=false;
                    // clearInterval(this.intervalTbqd);
                    // this.intervalTbqd=null;
                    this.getData();
                    let obj={
                        lx:'tb',
                        data:{
                            index:0,
                            msg:'2',
                            all:true
                        }
                    }
                    this.$emit('send',JSON.stringify(obj));
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                 this.$refs.qdCom.waitLoading = false
            }).catch(()=>{

            })
        },
        //扫码签到
        ewmQd(e){
            this.$message({
                type:'success',
                message:"签到成功！"
            })
            this.visible=false;
            // clearInterval(this.intervalTbqd);
            // this.intervalTbqd=null;
            this.getData();
            let obj={
                lx:'tb',
                data:{
                    index:0,
                    msg:'2',
                    all:true
                }
            }
            this.$emit('send',JSON.stringify(obj));
        }, 
    },
    mounted(){
        this.getData();

        // 每半分钟重新拉取一次数据
        this.preciseInterval = new PreciseInterval(this.getData, 30000)
    },
    beforeDestroy(){
        this.preciseInterval?.stop();
    }
}
</script>
<style lang="less" scoped>
   
</style>